export enum UnivisionEntitlement {
  FREE_DTC = 'urn:package:dtc:free',
  PREMIUM_DTC = 'urn:package:dtc:univision',
  VIP = 'urn:package:superuser',
  FREE_TVE = 'urn:package:tve:free',
  FREE = 'urn:package:free',
  BLOCKED = 'blocked',
}
